import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';
import { useAuth } from '../auth/AuthContext';

export default function RegisterPage() {
  const { register } = useAuth();
  const [form, setForm] = useState({
    orgName: '', displayName: '', email: '', password: '', confirm: '',
  });
  const [agreed, setAgreed] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (form.password !== form.confirm) {
      setError('Passwords do not match.');
      return;
    }
    if (!agreed) {
      setError('You must read and agree to the Terms of Use to create an account.');
      return;
    }
    setLoading(true);
    try {
      await register({
        orgName: form.orgName.trim(),
        displayName: form.displayName.trim(),
        email: form.email.trim(),
        password: form.password,
      });
      setDone(true);
    } catch (err) {
      setError(err?.response?.data?.error || err.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <AuthLayout title="Check your email" footer={<Link to="/login">Back to sign in</Link>}>
        <div className="auth-success">
          <p>
            We sent a verification link to <strong>{form.email}</strong>. Click it
            to activate your account, then sign in.
          </p>
          <p className="auth-hint">
            Didn&apos;t get it? Check spam, or it may take a minute to arrive.
          </p>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Create your account"
      subtitle="Set up your organization and start recovering denied claims."
      footer={<>Already have an account? <Link to="/login">Sign in</Link></>}
    >
      <form className="auth-form" onSubmit={submit}>
        {error && <div className="auth-error">{error}</div>}
        <label className="auth-field">
          <span>Organization name</span>
          <input name="orgName" value={form.orgName} onChange={onChange}
                 placeholder="Acme Revenue Cycle" disabled={loading} required />
        </label>
        <label className="auth-field">
          <span>Your name</span>
          <input name="displayName" value={form.displayName} onChange={onChange}
                 placeholder="Jordan Smith" disabled={loading} />
        </label>
        <label className="auth-field">
          <span>Work email</span>
          <input name="email" type="email" value={form.email} onChange={onChange}
                 placeholder="you@company.com" autoComplete="email" disabled={loading} required />
        </label>
        <label className="auth-field">
          <span>Password</span>
          <input name="password" type="password" value={form.password} onChange={onChange}
                 placeholder="At least 8 characters" autoComplete="new-password" disabled={loading} required />
        </label>
        <label className="auth-field">
          <span>Confirm password</span>
          <input name="confirm" type="password" value={form.confirm} onChange={onChange}
                 placeholder="Re-enter password" autoComplete="new-password" disabled={loading} required />
        </label>
        <label className="auth-consent">
          <input
            type="checkbox"
            name="agreed"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            disabled={loading}
            required
          />
          <span>
            I have read, understood, and agree to the{' '}
            <Link to="/terms" target="_blank" rel="noopener noreferrer">Terms of Use</Link>.
          </span>
        </label>
        <button type="submit" className="auth-submit" disabled={loading || !agreed}>
          {loading ? 'Creating account…' : 'Create account'}
        </button>
      </form>
    </AuthLayout>
  );
}
